import { Module } from 'wrapper6'
import { RootStore } from '../public/datastores/rootStore'

var $ = jQuery

export default class AddToCart extends Module {
  ready() {
    $(document).on('click', '[data-add-to-cart]', async e => {
      e.stopPropagation()
      e.stopImmediatePropagation()
      e.preventDefault()
      if (e.target.dataset.addToCart) {
        e.target.classList.add('loading')
        await RootStore.getInstance().cart.addEventGroups([
          window['eventgroups_' + e.target.dataset.addToCart]
        ])
        e.target.classList.remove('loading')
      }
    })
  }
}
